import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Row, Col, Label, Button, Input } from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import axios from 'axios';
import { api } from '../../config';
import 'react-toastify/dist/ReactToastify.css';
import DmutInvitationDataTable from './component/DmutInvitationDataTable';
import logger from '../../utils/logger';
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const DmutInvitationTab = ({
  goBack,
  ids,
  form,
  setForm,
  token,
  handleSaveDraftProc,
  handleSaveCompleteDmut,
}) => {
  const [subStatus, setSubStatus] = useState({ items: [] });
  const subStatusRef = useRef(subStatus);
  subStatusRef.current = subStatus;
  const [selectedMulti2, setSelectedMulti2] = useState([]);
  const [subStatusTitles, setSubStatusTitles] = useState([]);
  const procurementId = ids;
  const [selectedCategories, setSelectedCategories] = useState([]);
  const dmutTableRef = useRef();

  const handleSelectionChange = procurementMitra => {
    setForm(prev => ({ ...prev, procurementMitra }));
  };

  const handleFormCheckBoxChange = e => {
    const { name, checked } = e.target;
    setForm({
      ...form,
      [name]: checked ? 1 : 0,
    });
  };

  const fetchInitialCategory = useCallback(
    async procurementId => {
      try {
        const res = await axios.get(
          `${api.API_URL}/procurement/get-procurement-cargo-category?ProcurementId=${procurementId}`,
          {
            withXSRFToken: true,
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: `application/json`,
            },
          }
        );
        const items = res.items || [];
        const categories = items.map(item => item.category);
        setSelectedCategories(categories);
      } catch (err) {
        logger.error('Gagal mengambil data kategori:', err);
      }
    },
    [token]
  );

  const fetchSubStatus = useCallback(async () => {
    try {
      const response = await fetch(`${api.API_URL}/substatus`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setSubStatus({ items });
      return items;
    } catch (error) {
      logger.error('Error fetchSubStatus:', error);
      return [];
    }
  }, [token]);

  const fetchSubStatusGet = useCallback(
    async procurementId => {
      try {
        const response = await fetch(
          `${api.API_URL}/procurement/get-procurement-substatus?procurementId=${procurementId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const result = await response.json();

        if (result.success && result.data) {
          const masterItems =
            subStatusRef.current.items.length > 0
              ? subStatusRef.current.items
              : await fetchSubStatus();

          // One-liner validation
          const selected = (
            Array.isArray(result.data.subStatusId)
              ? result.data.subStatusId
              : []
          ).map(id => {
            const match = masterItems.find(opt => opt.value === id);
            return {
              value: id,
              label: match ? match.label : id,
            };
          });

          setSelectedMulti2(selected);
        } else {
          logger.warn('Data tidak ditemukan:', result);
          setSelectedMulti2([]);
        }
      } catch (error) {
        logger.error('Error fetchSubStatusGet:', error);
        setSelectedMulti2([]);
      }
    },
    [token, fetchSubStatus]
  );

  useEffect(() => {
    const init = async () => {
      if (!procurementId) return;
      fetchInitialCategory(procurementId);
      await fetchSubStatus(); // step 1
      await fetchSubStatusGet(procurementId); // step 2
    };
    if (procurementId) init();
  }, [fetchInitialCategory, fetchSubStatus, fetchSubStatusGet, procurementId]);

  useEffect(() => {
    if (!procurementId || selectedCategories.length === 0) return;
    const postCategory = async () => {
      const payload = {
        procurementId,
        category: selectedCategories,
      };
      try {
        axios.post(
          `${api.API_URL}/procurement/create-procurement-cargo-category`,
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // eslint-disable-next-line prettier/prettier
      } catch (err) {
        logger.error('Error DMUT Invitation useEffect: ', err);
      }
    };
    postCategory();
  }, [selectedCategories, procurementId, token]);

  const handleCheckboxChange = event => {
    const { value, checked } = event.target;
    setSelectedCategories(prev =>
      checked ? [...prev, value] : prev.filter(item => item !== value)
    );
  };

  function handleMulti2(selectedMulti2) {
    setSelectedMulti2(selectedMulti2);
    const valuesOnly = Array.isArray(selectedMulti2)
      ? selectedMulti2.map(item => item.value)
      : [];
    const titlesOnly =
      valuesOnly.length > 0 ? selectedMulti2.map(item => item.label) : [];
    setSubStatusTitles(titlesOnly);

    const payload = {
      procurementId: procurementId, // langsung string UUID
      subStatus: valuesOnly,
    };

    axios.post(
      `${api.API_URL}/procurement/create-procurement-substatus`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }

  return (
    <React.Fragment>
      <Row>
        <div>
          <Row>
            <Col sm={12}>
              <div color='dark' className='d-flex align-items-center mb-2  '>
                <div className='flex-grow-1'>
                  <h5 className='mb-1'>
                    <i className='ri-mail-send-line me-2'></i>
                    Invitation Information
                  </h5>

                  <p className='text-muted mb-2 fs-12 '>
                    Set the invitation criteria, confirm the terms, and select
                    bidders from the DMUT list.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div className='mb-3'>
          <Row>
            <Col sm={12}>
              <div
                className='d-flex align-items-center '
                style={{
                  borderTopColor: '#b0b8b2',
                  borderTopWidth: '1px',
                  borderTopStyle: 'solid',
                }}
              >
                <div className='flex-grow-1'>
                  <Label
                    for='choices-payment-type'
                    className='form-label  text-uppercase fw-semibold'
                  >
                    Invitation Criteria
                  </Label>
                </div>
              </div>
            </Col>

            <Col lg={12}>
              <div className='dmut-callout mb-3'>
                <i className='ri-information-line'></i>
                <div>
                  <strong>Complete Required Inputs</strong>
                  <p className='mb-0'>
                    In order to proceed with the pricing, you must first define
                    the Quantity and Delivery Terms
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={3}>
              <div className='mb-3'>
                <Label
                  htmlFor='choices-multiple-remove-button'
                  className='form-label text-muted'
                >
                  Sub Status
                </Label>
                <Select
                  name='subStatusId'
                  id='subStatusId'
                  //value={selectedMulti2}
                  value={selectedMulti2}
                  isMulti={true}
                  isClearable={true}
                  onChange={handleMulti2}
                  // onChange={() => {
                  //   handleMulti2();
                  // }}
                  options={subStatus.items}
                  isDisabled={form.isProcurementCompleted !== false}
                />
              </div>
            </Col>

            <Col sm={4}>
              <div className='mb-2'>
                <Label htmlFor='billinginfo-firstName' className='form-label'>
                  Cargo Category :
                </Label>
              </div>
              <div className='form-check form-check-inline form-switch form-switch-secondary mb-2'>
                <Input
                  className='form-check-input'
                  type='checkbox'
                  role='switch'
                  id='isInformationAboutDMUTConfirmedFuel'
                  name='isInformationAboutDMUTConfirmedFuel'
                  value='Fuel'
                  checked={selectedCategories.includes('Fuel')}
                  onChange={handleCheckboxChange}
                  disabled={form.isProcurementCompleted !== false}
                  //isDisabled={form.isProcurementCompleted}
                />
                <Label
                  className='form-check-label'
                  htmlFor='isInformationAboutDMUTConfirmedFuel'
                >
                  Fuel
                </Label>
              </div>
              <div className='form-check form-check-inline form-switch form-switch-secondary mb-2'>
                <Input
                  className='form-check-input'
                  type='checkbox'
                  role='switch'
                  id='isInformationAboutDMUTConfirmedPetrochemical'
                  name='isInformationAboutDMUTConfirmedPetrochemical'
                  value='Petrochemical'
                  checked={selectedCategories.includes('Petrochemical')}
                  onChange={handleCheckboxChange}
                  disabled={form.isProcurementCompleted !== false}
                />
                <Label
                  className='form-check-label'
                  htmlFor='isInformationAboutDMUTConfirmedPetrochemical'
                >
                  Petrochemical
                </Label>
              </div>
              <div className='form-check form-check-inline form-switch form-switch-secondary mb-2'>
                <Input
                  className='form-check-input'
                  type='checkbox'
                  role='switch'
                  id='isInformationAboutDMUTConfirmedLPG'
                  name='isInformationAboutDMUTConfirmedLPG'
                  value='LPG'
                  checked={selectedCategories.includes('LPG')}
                  onChange={handleCheckboxChange}
                  disabled={form.isProcurementCompleted !== false}
                />
                <Label
                  className='form-check-label'
                  htmlFor='isInformationAboutDMUTConfirmedLPG'
                >
                  Liquid Petroleum Gas (LPG)
                </Label>
              </div>
            </Col>
            <Col sm={5} className='d-flex align-items-end mb-4 ps-0'>
              {!form.isProcurementCompleted && (
                <Button
                  color='success'
                  className='btn-label btn btn-sm'
                  onClick={() => dmutTableRef.current?.refresh()}
                >
                  {' '}
                  <i className='ri-refresh-line label-icon align-middle fs-16 '></i>{' '}
                  Synch DMUT{' '}
                </Button>
              )}
            </Col>
          </Row>

          <Row>
            <Col lg={5}>
              <div className='mb-2 bor border-top  border-top-dashed '>
                <Label
                  for='choices-payment-type'
                  className='form-label  text-uppercase fw-semibold'
                >
                  Invitation Confirmation
                </Label>

                <p className='text-muted mb-2 fs-12 '>
                  Read and accept both confirmations below to authorize the
                  invitation.
                </p>
              </div>

              <div className='consent-card mt-3 mt-lg-2'>
                <div className='d-flex form-check form-switch form-switch-secondary mb-0'>
                  <div className='flex-shrink-0'>
                    <Input
                      className='form-check-input'
                      type='checkbox'
                      role='switch'
                      id='isInformationAboutDMUTConfirmed'
                      name='isInformationAboutDMUTConfirmed'
                      checked={form.isInformationAboutDMUTConfirmed || false}
                      onChange={e => {
                        handleFormCheckBoxChange(e);
                      }}
                      disabled={form.isProcurementCompleted !== false}
                    />
                  </div>
                  <div className='flex-grow-1 ms-2 '>
                    By Initiating the bidder invitation process within the
                    system, the User hereby expressly acknowledge, agrees, and
                    authorizes the issuance of procurement invitations to all
                    business entities retrieved from DMUT system, filtered based
                    on the sub-status and cargo category selected by the User.
                    These entities shall be considered formally invited to
                    participated in the applicable procurement, tender, or
                    auction process..
                  </div>
                </div>
              </div>
              <div className='consent-card mt-3 mt-lg-2'>
                <div className='d-flex form-check form-switch form-switch-secondary mb-0'>
                  <div className='flex-shrink-0'>
                    <Input
                      className='form-check-input'
                      type='checkbox'
                      role='switch'
                      id='isAcknowledgedDMUT'
                      name='isAcknowledgedDMUT'
                      checked={form.isAcknowledgedDMUT || false}
                      onChange={e => {
                        handleFormCheckBoxChange(e);
                      }}
                      disabled={form.isProcurementCompleted !== false}
                    />
                  </div>
                  <div className='flex-grow-1 ms-2 '>
                    By Initiating the bidder invitation process within the
                    system, the User hereby expressly acknowledge, agrees, and
                    authorizes the issuance of procurement invitations to all
                    business entities retrieved from DMUT system, filtered based
                    on the sub-status and cargo category selected by the User.
                    These entities shall be considered formally invited to
                    participated in the applicable procurement, tender, or
                    auction process..
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={7}>
              <div className='mb-2 bor border-top  border-top-dashed '>
                <Label
                  for='choices-payment-type'
                  className='form-label  text-uppercase fw-semibold'
                >
                  DMUT List
                </Label>

                <p className='text-muted mb-2 fs-12 '>
                  Companies retrieved from DMUT that match the selected
                  criteria.
                </p>
              </div>
              <DmutInvitationDataTable
                ref={dmutTableRef}
                procurementId={ids}
                token={token}
                subStatusTitles={subStatusTitles}
                cargoCategories={selectedCategories}
                onSelectionChange={handleSelectionChange}
                selectedMitraList={form.procurementMitra || []}
                procurementType={form.procurementType}
                isProcurementCompleted={form.isProcurementCompleted}
              />
            </Col>
          </Row>
        </div>

        <div className='req-actionbar d-print-none'>
          <button
            type='button'
            className='btn btn-light btn-label previestab me-auto'
            onClick={() => {
              goBack();
            }}
          >
            <i className='ri-arrow-left-line label-icon align-middle fs-16 me-2'></i>
            Back to Submit Document
          </button>
          {!form.isDMUTInvitationCompleted && (
            <button
              type='button'
              className='btn btn-light btn-label'
              onClick={handleSaveDraftProc}
            >
              <i className='ri-stack-line label-icon align-middle fs-16 me-2'></i>
              Save as Draft
            </button>
          )}
          {form.isProcurementCompleted === false && (
            <button
              type='button'
              className='btn btn-primary btn-label right nexttab'
              onClick={handleSaveCompleteDmut}
            >
              <i className='ri-truck-line label-icon align-middle fs-16 ms-2'></i>
              Save & Complete
            </button>
          )}
        </div>
      </Row>
    </React.Fragment>
  );
};

export default DmutInvitationTab;
